import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  for: "report_upload",
  class: "mr-6"
}
const _hoisted_2 = { type: "button" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Lae CSV fail ülesse ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonAdd = _resolveComponent("ButtonAdd")!
  const _component_ClinicsReportsUploadModal = _resolveComponent("ClinicsReportsUploadModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ButtonAdd, {
          class: "flex items-center",
          color: "lightgreen"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("input", {
      type: "file",
      id: "report_upload",
      name: "report_upload",
      accept: ".csv",
      class: "hidden",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onReportSelected && _ctx.onReportSelected(...args)))
    }, null, 32),
    (_ctx.addRowsModal)
      ? (_openBlock(), _createBlock(_component_ClinicsReportsUploadModal, {
          key: 0,
          onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowsModal = false)),
          items: _ctx.reportRows
        }, null, 8, ["items"]))
      : _createCommentVNode("", true)
  ]))
}